// removed by extract-text-webpack-plugin
module.exports = {"rich-form":"rich-form__ZY0jx","errortips-wrapper":"errortips-wrapper__3wghV","errortips":"errortips__1qOtL","errtips":"errtips__2Nmep","field-help":"field-help__OgQOu","submit":"submit__2CEj0","btn-label":"btn-label__DwdB8","success":"success__3CSIo","error":"error__om73Y","labeled-input":"labeled-input__26P7w","input-label":"input-label__WlB_K"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RichForm/styles/main.scss
// module id = 2143
// module chunks = 1